<template>
  <page-layout class="gallery_series">

    <div class="title">
      <div class="title_top">
        <p>Gallery</p>
      </div>
    </div>

    <article class="inner">

			<div class="gallery_sch">
        <h3><router-link to="/gallery">Gallery</router-link><em>&gt;</em><b>{{getSeriesTitle}}</b></h3>
				<div class="sch_box">
          <input type="text" placeholder="갤러리검색" v-model="keyword" @keyup.enter="search"><a class="sch_btn" href="javascript:" @click="search()" >검색</a>
				</div>
        <a href="javascript:" class="reset" @click="reset()">초기화</a>
			</div>

      <div class="list_gallery series_results album_results">
        <ul>
          <li class="ctnr" @click="goAlbum(album)" v-for="album in getAlbums" :key="album.idx">
          	<img v-if="isFileExist(album.poster_img)" :src="album.poster_img.url" class="fit_img"/>
          	<div class="subj">
          		<h5>{{album.title}}</h5>
          		<h6><b>{{album.image_cnt}}</b>개의 사진</h6>
          	</div>
          </li>
        </ul>
      </div>

    </article>

  </page-layout>
</template>

<script>
	import Vue from 'vue'
  import { QDialog, Loading } from 'quasar'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import PageLayout from '../layouts/PageLayout'
  import { mapGetters } from 'vuex'
  export default {
    name: "GallerySeries",
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      QDialog,
      Loading,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getSeriesTitle}`,
        titleTemplate: '%s',
        meta: this.getSeoMeta
      }
    },
    data () {
      return {
        isOpenDialog: false,
        isModalInnerBox: true,
        selectedAlbum: {},
        keyword: '',
      }
    },
    activated () {
      this.$store.dispatch('callSeries').then(() => {
        const index = this.getSeries.findIndex(row => row.parameter === this.getRouteParamsSeries)
        if (index < 0) this.$router.replace('/gallery')
      })
      this.$store.dispatch('loadAlbums', this.getRouteParamsSeries)
    },
    deactivated() {
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getSeries',
        'getAlbums',
        'isExistAlbumData'
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getSeriesInfo () {
        return this.getSeries.find(row => row.parameter === this.getRouteParamsSeries)
      },
      getSeriesTitle () {
        return this.getSeriesInfo ? this.getSeriesInfo.title : ''
      },
      getRouteParamsSeries () {
        return this.$route.params.series
      },
      getSeoMeta () {
        return this.getSeriesInfo ? this.getSeriesInfo.seo_meta : []
      },
    },
		methods: {
      ...CommonMethods,

      goAlbum (row) {
        this.$router.push(row.link_url)
      },
      search () {
        this.$router.replace('/gallery/search/' + this.keyword)
        this.keyword = ''
      },
      reset () {
        this.$router.replace('/gallery')
        this.keyword = ''
      },
    }
  }
</script>

<style scoped>
  .gallery_series {
    position: relative;
    top: -40px;
  }
  .gallery_series .title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 40px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
	.gallery_sch {
    position: relative;
		text-align: right;
		margin: 0 0 20px 0;
  }
	.gallery_sch h3 {
    position: absolute;
		left: 0;
		font-size: 30px;
		font-weight: 500;
		letter-spacing: -0.03em;
  }
	.gallery_sch h3 b {
		font-weight: 900;
  }
	.gallery_sch h3 em {
		font-size: 18px;
		font-weight: 600;
		color: #888;
    font-style: normal;
		padding: 0 15px;
  }
	.gallery_sch h3 a {
		color: #008c03;
  }
	.gallery_sch h3 a:hover {
		text-decoration: underline;
  }
  .gallery_sch .sch_box {
		display: inline-block;
    width: 290px;
    height: 40px;
		background: #f5f5f5;
		border: 1px solid #000;
  }
  .gallery_sch .sch_box input {
    width: 208px;
    height: 40px;
    padding: 0 12px;
    font-size: 18px;
    font-weight: 600;
    color: #008c03;
    border: 0;
  }
  .gallery_sch .sch_box input:disabled {
    background: #222 !important;
  }
  .gallery_sch .sch_box input::-webkit-input-placeholder {
    color: #bbb;
    font-weight: 500;
  }
  .gallery_sch .sch_box input:-moz-placeholder {
    color: #bbb;
  }
  .gallery_sch .sch_box input::-moz-placeholder {
    color: #bbb;
  }
  .gallery_sch .sch_box input:-ms-input-placeholder {
    color: #bbb;
  }
	.gallery_sch .sch_btn {
    display: inline-block;
    width: 80px;
    height: 38px;
    transition: all 0.2s;
		background: #000;
		font-size: 18px;
		font-weight: 600;
		color: #fff;
		padding: 8px 0;
		text-align: center;
  }
	.gallery_sch .reset {
    display: inline-block;
    width: 70px;
    height: 40px;
    transition: all 0.2s;
		font-size: 16px;
		font-weight: 500;
		color: #000;
		padding: 9px 0;
		text-align: center;
		border: 1px solid #999;
		margin-left: 5px;
  }
  .list_gallery li {
    position: relative;
    display: inline-block;
    margin: 0 5px 5px 0;
    width: calc((100% - 10px) / 3);
    height: 400px;
    cursor: pointer;
  }
  .list_gallery li:nth-child(3n) {
    margin-right: 0;
  }
  .list_gallery li img {
    width: 100%;
    transition: .15s;
  }
  .list_gallery li:hover img {
    filter: brightness(120%);
  }
  .list_gallery li .subj {
    position: absolute;
		bottom: 0;
		display: block;
		width: 100%;
		background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1.0) 80%);
		color: #fff;
		padding: 40px 30px 20px 30px;
		box-sizing: border-box;
  }
  .list_gallery li .subj h5 {
		font-size: 22px;
    font-weight: 700;
  }
  .list_gallery li .subj h6 {
		font-size: 15px;
    font-weight: 300;
		color: #00ff64;
  }
  .list_gallery li .subj h6 b {
		font-weight: 900;
  }

  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
</style>
